export default "__VITE_ASSET__C6CX8Lxp__"